// Filtering a company list by what was typed, term by term.
//
// A native <datalist> matches the typed text as one substring, which is why
// "me ca ca" showed everything carrying "me" or "ca" anywhere. Here the text is
// split on whitespace and every term has to be found - and a term typed twice has
// to be found twice, as separate occurrences. "me ca ca" then means: one "me" and
// two "ca", which "METRO CASH & CARRY ROMANIA SRL" satisfies (metro, cash, carry)
// and "ABC MEDICAL CENTER SRL" does not.

// How many times `needle` fits in `haystack` without reusing characters.
export const occurrences = (haystack, needle) => {
  if (!needle) return 0

  let count = 0
  let from = 0

  for (;;) {
    const at = haystack.indexOf(needle, from)
    if (at === -1) return count

    count += 1
    from = at + needle.length
  }
}

// { me: 1, ca: 2 } for "me ca ca"
export const termCounts = (text) =>
  String(text)
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean)
    .reduce((counts, term) => ({ ...counts, [term]: (counts[term] || 0) + 1 }), {})

export const matchesTerms = (label, counts) => {
  const haystack = String(label).toLowerCase()

  return Object.entries(counts).every(([term, count]) => occurrences(haystack, term) >= count)
}
